

import React, { useCallback } from 'react';
import Main404 from '../../components/Main404';
import { Container, Title, SubTitle } from './styles';
import { useHistory } from 'react-router-dom';
import { Button } from 'react-bootstrap';




const RegisterProject: React.FC = () => {

    const history = useHistory()


    const handleSistem = useCallback((e) => {
        e.preventDefault()
        history.push(`/`)
    }, [history])



    return (

        <Main404 >
            <Container>
                <Title>404</Title>
                <SubTitle>PÁGINA NÃO ENCONTRADA!</SubTitle>
                <SubTitle id="secundSubTitle">VOCÊ PARECE ESTAR TENTANDO ENCONTRAR O CAMINHO DO SISTEMA</SubTitle>
                <Button type="button" onClick={handleSistem}>Sistema</Button>
            </Container>
        </Main404>




    );
};


export default RegisterProject;